import { render } from "./dlt-5.vue?vue&type=template&id=78e87a64&scoped=true"
import script from "./dlt-5.vue?vue&type=script&lang=js"
export * from "./dlt-5.vue?vue&type=script&lang=js"

import "./dlt-5.vue?vue&type=style&index=0&id=78e87a64&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e87a64"]])

export default __exports__